module.exports = __webpack_public_path__ + "static/media/Team 2 - Women Connect.b240fd2c.jpg";